import { GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid-pro';
import { BALANCE_COLUMN_FIELDS } from '../RosterPlan.consts';
import {
  StyledPanelBox,
  StyledRosterPlanDataGridPro
} from '../RosterPlan.styles';
import NoDataGridRows from './NoDataGridRows';
import { getOpenRequestRowHeight } from '../utils/getOpenRequestRowHeight';
import type { RosterOpenRequestsGridProps } from './RosterOpenRequestsGrid.types';

const COLUMNS_WITH_NO_DASHED_BORDER = ['sortorder', ...BALANCE_COLUMN_FIELDS];

const RosterOpenRequestsGrid = ({
  rows,
  columns,
  apiRef,
  isLoading,
  getRowClassName,
  columnGroupingModel
}: RosterOpenRequestsGridProps) => {
  'use memo';

  return (
    <StyledPanelBox>
      <StyledRosterPlanDataGridPro
        rows={rows}
        className="open-requests-grid"
        columns={columns}
        apiRef={apiRef}
        getRowId={(row) => row.functionId}
        hideFooter
        getRowClassName={getRowClassName}
        getRowHeight={(params) => getOpenRequestRowHeight(params?.model)}
        initialState={{
          pinnedColumns: {
            left: [
              GRID_CHECKBOX_SELECTION_COL_DEF.field,
              'sortorder',
              'functionName'
            ],
            right: [
              GRID_CHECKBOX_SELECTION_COL_DEF.field,
              ...BALANCE_COLUMN_FIELDS
            ]
          }
        }}
        columnGroupingModel={columnGroupingModel}
        firstColumnName="functionName"
        slotProps={{
          noRowsOverlay: { isLoading }
        }}
        slots={{
          noRowsOverlay: NoDataGridRows
        }}
        columnsWithNoDashedBorder={COLUMNS_WITH_NO_DASHED_BORDER}
      />
    </StyledPanelBox>
  );
};

export default RosterOpenRequestsGrid;
